export default {
    login: {
        username: "Nombre de usuario",
        password: "Contraseña",
        button: "Entrar",
        error: "Error al iniciar sesión, revise sus datos",
        page_title: "Kevi, tu opinión vale recompensas",
        intro_title: "¡Valoramos tu opinión!",
        intro_body: "Completa el formulario y gana un bono.",
        coupons_title: "¡Consulta tus cupones!",
        coupons_body: "Accede y revisa los descuentos que ya ganaste.",
        invalid_link: "Enlace inválido.",
        used_link: "Enlace ya utilizado",
    },
    form: {
        save_error: "No se pudo enviar. Inténtalo de nuevo en unos instantes.",
        save_error_table: "Revisa la tabla: alguna celda no fue aceptada.",
        page_title: "Kevi, ¡tu opinión es muy importante!",
        submit: "Enviar",
        not_found: "Formulario no encontrado.",
        already_answered:
            "Ya respondiste esta encuesta el <strong>{date}</strong>. Podrás responder de nuevo <strong>{next}</strong>",
        unused_coupon:
            "Todavía tienes un cupón de descuento sin usar. Podrás responder de nuevo después de utilizar el cupón actual.",
        thanks_title: "¡Gracias!",
        thanks_message: "¡Tu opinión es muy importante!",
        coupon_prize:
            "{name}, ¡acabas de ganar <strong>{prize}</strong> en tu próxima compra!",
        coupon_valid_until: "Cupón válido hasta {date}",
        developed_with: "Desarrollado con",
    },
    user: {
        heading_known: "Nos gustaría saber un poco más sobre ti",
        heading: "Completa tus datos para finalizar",
        name: "Nombre",
        name_placeholder: "Escribe tu nombre",
        name_error: "Por favor ingresa tu nombre",
        last_name: "Apellido",
        last_name_placeholder: "Escribe tu apellido",
        last_name_error: "Por favor ingresa tu apellido",
        email: "Correo electrónico",
        email_placeholder: "Escribe tu correo electrónico",
        email_error: "Por favor ingresa un correo válido",
        phone: "Celular",
        phone_search: "Buscar...",
        phone_no_results: "No se encontraron resultados",
        phone_required: "Por favor ingresa tu celular",
        phone_invalid: "Por favor ingresa un celular válido",
        birthdate: "Fecha de nacimiento",
        birthdate_placeholder: "xx/xx/xxxx",
        birthdate_error: "Por favor revisa tu fecha de nacimiento",
    },
    question: {
        yes: "Sí",
        no: "No",
        select_option: "Selecciona una opción",
        select_options: "Selecciona una o más opciones",
        select_at_least_one: "Selecciona al menos una opción.",
        nps_low: "No recomendaría",
        nps_high: "Recomendaría",
        ces_hard: "Extremadamente difícil",
        ces_easy: "Extremadamente fácil",
        file_drop: "Haz clic o arrastra tus archivos aquí",
        file_uploading: "Enviando archivos...",
        file_hint: "{types} — hasta {size} MB (máx. {max})",
        file_types_any: "Archivos permitidos por Kevi",
        file_types_image: "Imágenes",
        file_types_image_dst: "Imágenes o bordado .DST",
        file_types_dst: "Bordado .DST",
        file_invalid_type: "{name}: formato no aceptado",
        file_too_large: "{name}: supera {size} MB",
        file_too_many: "Puedes enviar un máximo de {max} archivo(s).",
        file_upload_error: "No se pudieron enviar los archivos. Inténtalo de nuevo.",
        table_row: "Fila {n}",
        table_add_row: "Agregar fila",
        table_duplicate: "Duplicar fila",
        table_remove: "Eliminar fila",
        table_min_rows: "Completa al menos {n} fila(s).",
        table_max_rows: "Como máximo {n} filas.",
        table_invalid_cells: "Revisa {n} celda(s), empezando por {where}.",
        table_formula_error: "No se pudo calcular esta celda",
        table_paste_skipped: "{n} fila(s) no cupieron en la tabla.",
    },
};
